import {
  RECEIVE_ACCESSORIES,
  REQUEST_ACCESSORIES,
  REQUEST_ACCESSORY,
  RECEIVE_ACCESSORY,
  REQUEST_ACCESSORY_PRICE,
  RECEIVE_ACCESSORY_PRICE,
  ADD_ACCESSORY_TO_CART,
  ADDED_ACCESSORY_TO_CART,
  ACCESSORY_QUANTITY_CHANGE,
  ACCESSORY_VARIANT_CHANGE,
} from '../../ActionsConst';
import { requestAccessories, receiveAccessories } from './accessories';
import {
  receiveAccessory,
  requestAccessory,
  receiveAccessoryPrice,
  requestAccessoryPrice,
  accessoryVariantChange,
} from './accessory';
import { addAccessoryToCart, addedAccessoryToCart } from './cart';
import { quantityChange } from './quantity';

export const initialState = {
  isLoading: true,
  items: [],
  activeItem: {
    isLoading: true,
  },
  total: 0,
  activeTab: '',
};

// eslint-disable-next-line complexity
const accessories = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ACCESSORIES:
      return requestAccessories(state, action);
    case RECEIVE_ACCESSORIES:
      return receiveAccessories(state, action);
    case REQUEST_ACCESSORY:
      return requestAccessory(state);
    case RECEIVE_ACCESSORY:
      return receiveAccessory(state, action);
    case REQUEST_ACCESSORY_PRICE:
      return requestAccessoryPrice(state);
    case RECEIVE_ACCESSORY_PRICE:
      return receiveAccessoryPrice(state, action);
    case ACCESSORY_QUANTITY_CHANGE:
      return quantityChange(state, action);
    case ADD_ACCESSORY_TO_CART:
      return addAccessoryToCart(state);
    case ADDED_ACCESSORY_TO_CART:
      return addedAccessoryToCart(state, action);
    case ACCESSORY_VARIANT_CHANGE:
      return accessoryVariantChange(state, action);
    default:
      return state;
  }
};

export default accessories;
